import './main.css'

import { LoadingOutlined } from '@ant-design/icons';
import { Button, Space, Spin } from 'antd';
import { useLocation,useNavigate  } from "react-router-dom";

import callAPI from '../../comps/fetch/main'
import { useEffect, useState } from 'react';
import { jwtDecode } from "jwt-decode";


function SPLOGIN(){

    
    const [loading, setLoading] = useState()
    const [data, setData] = useState({})

    const [error, setError] = useState()

    const navigate = useNavigate();
    const [shopName, setShopName] = useState()
    
    let url = window.location.href

    useEffect(() => {

        const url = new URL(window.location.href);
        const idm_token = url.searchParams.get('idm_token');
        const shop =  url.searchParams.get('shop');
        localStorage.setItem("userData" , JSON.stringify( jwtDecode(idm_token)))
        localStorage.setItem("shopify_store" , shop)


        if(idm_token){
            setShopName(shop)
            localStorage.setItem("token" , idm_token)
            sessionStorage.clear();
            window.location.href = "/shopify";
        }
        
        
    } , [])



    return(
        <div className='fb-rdr'>
           <p>{shopName} Connected</p>
           <br/>
           <Button href='/shopify'>Go to Home</Button>
        </div>
    )
}
export default SPLOGIN;